import ChartCard from '../common/ChartCard';
import LineChart from './LineChart';
import useMetric from '../../hooks/useMetric';

export default function EngagementTrendChart() {
  const { status, data, error, retry } = useMetric('engagementTrend');
  const hasData = data && data.series.some((s) => s.values.some((v) => v > 0));
  return (
    <ChartCard
      testId="chart-engagement-trend" title="Engagement Trend" subtitle="Visitors vs conversations"
      status={status === 'success' && !hasData ? 'empty' : status} error={error} onRetry={retry}
      emptyText="No engagement recorded for this period."
    >
      {hasData && <LineChart labels={data.labels} series={data.series} />}
    </ChartCard>
  );
}
